import React, { useState, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import './my-referrals.css';

import ReferralRecords from './referral-records';
import PayoutPreference from '../../common/payment-preference.js';
import AlertConfirmModal from '../../common/AlertConfirmModal';
import PRainbowToast from '../../common/PRainbowToast';
import Spinner from 'react-bootstrap/Spinner';
import copy from 'copy-to-clipboard';
import MetaTags from 'react-meta-tags';
import currency from 'currency.js';
import { useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2.js';
import { ROLES } from '../../utils/constants.js';
import DefaultPUWidget from '../../Widgets/PU/Default/index.js';
import DefaultWidget from '../../Widgets/SU/Default/index.js';
import PageHeader from '../../common/PageHeader/index.js';

const MyReferrals = () => {
    const isMobile = useMediaQuery('(max-width: 899px)');

    const [user, setUser] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMonthly, setLoadingMonthly] = useState(false);
    const [loadingTotal, setLoadingTotal] = useState(false);
    const [monthEarning, setMonthEarning] = useState(0);
    const [totalUnpaid, setTotalUnpaid] = useState(0);
    const [show, setShow] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [showToast, setShowToast] = useState(false);

    const getUserInformation = async () => {
        setIsLoading(true);
        const userId = localStorage.getItem('loggedin_user');
        await axios.get(`/api/users/${userId}`)
            .then((response) => {
                setUser(response.data);
                localStorage.setItem(
                    'user',
                    JSON.stringify(response.data)
                );
            })
            .catch((error) => {
                console.log({ error });
            }).finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getUserInformation();
        getMonthEarning();
        getTotal();
    }, []);
    const link = `${process.env.MIX_APP_URL}?ref=${user.referral_id}`;

    const handleCopy = (e) => {
        e.preventDefault();
        copy(`${link}`, {
            debug: false,
            message: 'Click to copy link',
        });
        setShow(true);
        setAlertText('Copied Your Referral URL link: \n' + link);
    };

    const getMonthEarning = () => {
        setLoadingMonthly(true);
        axios.get('/api/earnings/monthly')
            .then(response => {
                setMonthEarning(response.data.total);
            })
            .catch(error => { })
            .finally(() => {
                setLoadingMonthly(false);
            });
    };

    const getTotal = () => {
        setLoadingTotal(true);
        axios.get('/api/earnings/total')
            .then(response => {
                setTotalUnpaid(response.data.total);
            })
            .catch(error => { })
            .finally(() => {
                setLoadingTotal(false);
            });
    };

    return (
        <>
            <AlertConfirmModal modalTitle="" modalBody={alertText} show={show} setShow={setShow} />
            <div className="container pt-4 mb-4">

                <MetaTags>
                    <title>My Referrals &#8211; Best way to make money as an influencer for your exclusive content</title>
                    <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
                </MetaTags>

                <Grid2
                    container
                    spacing={!isMobile ? 2 : 0}
                >
                    <Grid2 item md={8}>
                        <PageHeader title='My Referrals' />
                        <div className="refer-personal-details clearfix my-4">
                            <div className="float-left">
                                <div className="earning-container">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p><b>Current Month Earnings</b></p>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            {
                                                loadingMonthly
                                                    ? <Spinner animation="border" variant="primary" size="sm" />
                                                    : <p className="earning-money">{currency(monthEarning).format()}</p>
                                            }
                                        </div>
                                        <div className="col-md-6">
                                            <p><b>Total Referral Earnings</b></p>
                                        </div>
                                        <div className="col-md-6 text-right">
                                            {
                                                loadingTotal
                                                    ? <Spinner animation="border" variant="primary" size="sm" />
                                                    : <p className="earning-money">{currency(totalUnpaid).format()}</p>
                                            }
                                        </div>
                                        <div className="col-md-12">
                                            <p>Please note, if you do not reach the minimum payout ($200.00), your earnings will rollover to the next monthly payout.</p>

                                            <p>To receive your payments please enter your Paypal account email in the Payout Preference section below. Payments are issued in the first week of each month.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="float-right">
                                <div className="personal-referral-url text-center">
                                    <h6 className="text-uppercase"><b>Your Personal Referral URL</b></h6>
                                    <span>{process.env.MIX_APP_URL}?ref={isLoading ? <Spinner variant="primary" animation="border" size="sm" /> : user.referral_id}</span>
                                    <PRainbowToast
                                        show={showToast}
                                        setShow={setShowToast}
                                        message={`Copied Your Referral URL link: ${link}`}
                                        customStyle={{
                                            top: '150px',
                                            right: '45%'
                                        }}
                                    />
                                    <CopyToClipboard
                                        text={link}
                                        onCopy={() => setShowToast(true)}
                                    >
                                        <a className={`btn theme-btn theme-btn-bordered mt-4 mb-2${isLoading ? ' disabled' : ''}`}>Copy Link</a>
                                    </CopyToClipboard>
                                </div>
                            </div>
                        </div>

                        <div className="referral-records-container mb-4">
                            <ReferralRecords />
                        </div>

                        <div className="payout-pref-container mb-4">
                            <PayoutPreference page={'my-referrals'} user={user} />
                        </div>
                    </Grid2>

                    {
                        !isMobile
                            ? <Grid2 item className='pu-homepage__right' md={4}>
                                {
                                    user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                                }
                                {
                                    user && user.role == ROLES.SU ? <DefaultWidget /> : null
                                }
                            </Grid2>
                            : null
                    }
                </Grid2>
            </div>
        </>
    );
};

export default MyReferrals;
